var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentoCarro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3412_158383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8389 73.7534C54.9967 73.7534 64.8525 72.6228 64.8525 71.2283C64.8525 69.8337 54.9967 68.7031 42.8389 68.7031C30.6811 68.7031 20.8253 69.8337 20.8253 71.2283C20.8253 72.6228 30.6811 73.7534 42.8389 73.7534Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9962 6.65117L17.7505 11.7452C16.4037 11.9344 15.4653 13.1797 15.6546 14.5265L23.3304 69.1425C23.5197 70.4894 24.765 71.4278 26.1118 71.2385L62.3574 66.1445C63.7042 65.9552 64.6426 64.7099 64.4533 63.3631L56.7776 8.7471C56.5883 7.40026 55.343 6.46188 53.9962 6.65117Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6131 54.1649L27.0381 64.2904C27.2256 65.603 28.4382 66.5156 29.7508 66.328L41.4514 64.678C42.7639 64.4905 43.814 63.5154 44.1015 62.2153L53.452 19.0382C53.602 18.3507 53.627 17.6381 53.527 16.9381L52.9019 12.5129C52.8019 11.8003 52.1394 11.3003 51.4143 11.4003L47.3391 11.9753C46.4766 12.1003 45.7266 12.6379 45.3265 13.4129L26.0131 51.6648C25.6256 52.4398 25.4756 53.3149 25.6006 54.1649H25.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1881 47.4397L53.7894 43.8395",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0507 53.64L54.6644 50.0398",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9258 59.8528L39.5138 58.5027",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4756 36.2391L51.9768 32.514C52.3643 32.4515 52.6393 32.0764 52.5768 31.6889L51.8268 26.9637C51.7268 26.3136 51.1893 25.8136 50.5392 25.7511L45.2765 25.3761L27.1756 28.2387L24.838 29.8763C24.6629 30.0388 24.5754 30.2888 24.6129 30.5264L25.4755 35.9641C25.538 36.3516 25.913 36.6267 26.3005 36.5642L28.4756 36.2141V36.2391Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5631 23.3634L27.1631 28.2512L45.289 25.376L41.1013 21.3008C40.4387 20.6508 39.4887 20.3508 38.5762 20.5133L28.7632 22.0634C28.1131 22.1634 27.6131 22.7009 27.5631 23.3509V23.3634Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6509 21.5259L34.5634 27.3012L33.6509 21.5259Z",
    fill: "#FD9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6509 21.5259L34.5634 27.3012",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8133 38.4768C33.3008 38.2392 34.3134 36.8392 34.0759 35.3516C33.8384 33.864 32.4383 32.8515 30.9507 33.089C29.4631 33.3265 28.4506 34.7266 28.6881 36.2141C28.9256 37.7017 30.3257 38.7143 31.8133 38.4768Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.939 36.2391C47.4266 36.0016 48.4391 34.6015 48.2016 33.1139C47.9641 31.6264 46.564 30.6138 45.0765 30.8513C43.5889 31.0888 42.5763 32.4889 42.8138 33.9765C43.0513 35.464 44.4514 36.4766 45.939 36.2391Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3511 27.0261L37.5886 34.8015L36.3511 27.0261Z",
    fill: "#FD9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3511 27.0261L37.5886 34.8015",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3412_158383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.09,
    height: 67.7534,
    fill: "white",
    transform: "translate(15 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentoCarro);
export default __webpack_public_path__ + "static/media/documento-carro.75e72298.svg";
export { ForwardRef as ReactComponent };